import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns/esm'
import { styled, useTheme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import green from '@mui/material/colors/green';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import request from 'superagent'

const SnackBarIcon = styled(CheckCircleIcon)(({ theme }) => ({
  fontSize: 20,
  opacity: 0.9,
  marginRight: theme.spacing(1),
}));

export default function Form() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [dateStart, setDateStart] = useState(null);
  const [errorDateStart, setErrorDateStart] = useState(false);
  const [dateEnd, setDateEnd] = useState(null);
  const [errorDateEnd, setErrorDateEnd] = useState(false);
  const [name, setName] = useState('');
  const [errorName, setErrorName] = useState(false);
  const [organizer, setOrganizer] = useState('');
  const [errorOrganizer, setErrorOrganizer] = useState(false);
  const [location, setLocation] = useState('');
  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState(false);

  const minDate = new Date((new Date()).getFullYear() + 1, 0, 1);
  const maxDate = new Date((new Date()).getFullYear() + 1, 12, 0);

  const onDateStartChange = (date) => {
    setDateStart(date);
    setDateEnd(date);
  }

  const onDateEndChange = (date) => {
    setDateEnd(date);
  }

  const onChangeName = (event) => {
    setName(event.target.value);
    setErrorName(false);
  }

  const onChangeOrganizer = (event) => {
    setOrganizer(event.target.value);
    setErrorOrganizer(false);
  }

  const onChangeLocation = (event) => {
    setLocation(event.target.value);
  }

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
    setErrorEmail(false);
  }

  const resetForm = () => {
    setDateStart(null);
    setDateEnd(null);
    setName('');
    setOrganizer('');
    setLocation('');
    setEmail('');
    resetErrors();
  }

  const resetErrors = () => {
    setErrorDateStart(false);
    setErrorDateEnd(false);
    setErrorName(false);
    setErrorOrganizer(false);
    setErrorEmail(false);
  }

  const validateForm = () => {
    let isValid = true;

    // Validate date start
    if (dateStart === null) {
      setErrorDateStart(true);
      isValid = false;
    }

    // Validate date end
    if (dateEnd === null) {
      setErrorDateEnd(true);
      isValid = false;
    }

    // Validate name
    if (name.length === 0) {
      setErrorName(true);
      isValid = false;
    }

    // Validate organizer
    if (organizer.length === 0) {
      setErrorOrganizer(true);
      isValid = false;
    }

    // Validate email
    if (email.length === 0) {
      setErrorEmail(true);
      isValid = false;
    }

    return isValid;
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  }

  const send = () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);

    var dateStartFormatted = format(dateStart, 'dd.MM.yyyy');
    var dateEndFormatted = format(dateEnd, 'dd.MM.yyyy');

    request.post('https://formulare-schemmerhofen.de/veranstaltungen/backend.php')
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({
        command: "newevent",
        date_start: dateStartFormatted,
        date_end: dateEndFormatted,
        event_name: name,
        event_organizer: organizer,
        event_location: location,
        email: email
      })
      .end(function (err, res) {
        resetForm();
        setLoading(false);
        setSnackbarOpen(true);
      });
  }

  return (
    <Dialog fullScreen={fullScreen} open BackdropProps={{ style: { backgroundColor: "transparent" } }}>
      <DialogTitle>{"Veranstaltung eintragen"}</DialogTitle>
      <DialogContent>
        <DialogContentText>Der Veranstaltungskalender wurde fertig gestellt und ist auf der <a href="https://www.schemmerhofen.de/Home/Freizeit+_+Kultur/Veranstaltungskalender.html">Homepage der Gemeinde</a> einsehbar</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          href="https://formulare-schemmerhofen.de/veranstaltungen/preview.php"
          target="_blank"
          variant="contained">
          Vorschau alle Termine
        </Button>
        <Button
          onClick={resetForm}
          variant="contained"
          disabled={/*loading*/ true}>
          Formular zurücksetzen
        </Button>
        <LoadingButton
          onClick={send}
          variant="contained"
          /*loading={loading}*/
          disabled={true}
          color="primary"
          autoFocus>
          Veranstaltung erstellen
        </LoadingButton>
      </DialogActions>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}>
        <SnackbarContent
          message={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <SnackBarIcon />
              Ihre Veranstaltung wurde erfolgreich gespeichert
            </span>
          }
          action={[
            <IconButton color="inherit" onClick={handleSnackbarClose}>
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>,
          ]}
          style={{ backgroundColor: green[600] }} />
      </Snackbar>
    </Dialog>
  );
}
